import { openModal, closeModal } from './store/modal-actions';

export { createModalOpenedMiddleware } from './store/modal-opened-middleware';
export { createModalClosedMiddleware } from './store/modal-closed-middleware';

export const modalActions = {
  openModal,
  closeModal,
};
